import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/.app/layouts/default.vue")),
  none: defineAsyncComponent(() => import("/home/vsts/work/1/s/.app/layouts/none.vue")),
  skytouch: defineAsyncComponent(() => import("/home/vsts/work/1/s/.app/layouts/skytouch.vue")),
  empty: defineAsyncComponent(() => import("/home/vsts/work/1/s/layers/tairo/layouts/empty.vue"))
}